
import Chart from 'chart.js';
import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class DashboardChart extends Vue {
  @Prop({required: true})
  public chartType!: string;

  @Prop({required: true})
  public labels!: string[];

  @Prop({required: true})
  public values!: number[];

  @Prop({default: 'Total'})
  public datasetLabel!: string;

  @Prop({default: () => ['#1976d2', '#00a896', '#f9a825', '#ef5350', '#7e57c2', '#26a69a']})
  public colors!: string[];

  private chart: Chart | null = null;

  public mounted() {
    this.renderChart();
  }

  public beforeDestroy() {
    this.destroyChart();
  }

  @Watch('labels')
  @Watch('values')
  public onDataChange() {
    this.renderChart();
  }

  private renderChart() {
    this.destroyChart();

    const canvas = this.$refs.canvas as HTMLCanvasElement;
    if (!canvas) {
      return;
    }

    const context = canvas.getContext('2d');
    if (!context) {
      return;
    }

    this.chart = new Chart(context, {
      type: this.chartType,
      data: {
        labels: this.labels,
        datasets: [{
          label: this.datasetLabel,
          data: this.values,
          backgroundColor: this.colors,
          borderColor: '#ffffff',
          borderWidth: 2,
        }],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.chartType === 'doughnut',
          position: 'bottom',
          labels: {
            boxWidth: 10,
            fontColor: '#455a64',
          },
        },
        scales: this.chartType === 'horizontalBar' ? {
          xAxes: [{
            ticks: {
              beginAtZero: true,
              precision: 0,
            },
            gridLines: {
              color: '#eef2f7',
            },
          }],
          yAxes: [{
            gridLines: {
              display: false,
            },
          }],
        } : undefined,
        tooltips: {
          callbacks: {
            label: (tooltipItem, data) => {
              const label = data.labels && data.labels[tooltipItem.index] ? data.labels[tooltipItem.index] : this.datasetLabel;
              const value = this.values[tooltipItem.index] || 0;
              return `${label}: ${value.toLocaleString('pt-BR')}`;
            },
          },
        },
      },
    });
  }

  private destroyChart() {
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}
